import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Header from '../header';
import Footer from '../footer';

import './style.scss';
import {userCanAccess} from "../../utils/users";
import {checkIfLoggedInOrTermsAndConditions} from "../../utils/session";

const RootPage = (props) => {
  const loggedIn = useSelector((state) => state.session.loggedIn);
  const mustAcceptTermsUser = useSelector((state) => state.session.mustAcceptTermsUser);


  const className = checkIfLoggedInOrTermsAndConditions(mustAcceptTermsUser, loggedIn) ? 'logged-in' : 'logged-out';

  return (
    <div className={'main-container ' + className}>
      <div className='page-width'>
        <Header />
        <section className='content-area'>
          <Outlet />
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default RootPage;
